export default function KingmanHeroSection() {
  return (
    <section className="relative bg-[#1A365D] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1A365D] via-[#1A365D] to-[#0F2240]" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-36">
        <div className="max-w-3xl">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Kingman, AZ</p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Kingman <span className="text-[#F6C344]">Expedited</span> Passport Services
          </h1>
          <p className="text-white/70 text-lg md:text-xl leading-relaxed mb-8 max-w-2xl">
            Emergency and expedited passport services for Kingman, Historic Route 66, and Northwest Arizona — without the long drive to Phoenix or Las Vegas.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4 mb-10">
            <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap">
              Start My Passport <i className="ri-arrow-right-line"></i>
            </a>
            <a href="tel:8772530084" className="inline-flex items-center gap-2 text-white/80 hover:text-[#F6C344] font-medium text-base transition-colors whitespace-nowrap">
              <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-6">
            {[
              { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
              { icon: "ri-award-line", text: "A+ BBB Rating" },
              { icon: "ri-price-tag-3-line", text: "Best Price Guarantee" },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-white/50 text-xs">
                <i className={`${badge.icon} text-[#F6C344]`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}